import 'views/utils/setupDynamicAssetPath'

import logger from 'shared/services/logger'
import ready from 'views/utils/ready'
import polyfills from 'views/assets/scripts/polyfills'
import initStore from 'views/assets/scripts/initStore'
import expander from 'views/assets/scripts/expander'
import modal from 'views/assets/scripts/modal'
import passwordReveal from 'views/assets/scripts/passwordReveal'
import select from 'views/assets/scripts/select'
import asyncDataFetching from 'views/assets/scripts/asyncDataFetching'
import floatingLabel from 'views/assets/scripts/floatingLabel'
import menubarFlyout from 'views/assets/scripts/menubarFlyout'
import sticky from 'views/assets/scripts/sticky'
import hover from 'views/assets/scripts/hover'
import scrollToTop from 'views/assets/scripts/scrollToTop'
import iframeWithHtml from 'views/assets/scripts/iframeWithHtml'
import formControlValidation from 'views/assets/scripts/formValidation/formControlValidation'
import formValidation from 'views/assets/scripts/formValidation'
import handleUserSession from 'views/assets/scripts/handleUserSession'
import fetchUserSession from 'views/assets/scripts/fetchUserSession'
import tooltip from 'views/assets/scripts/tooltip'
import copyLink from 'views/assets/scripts/copyLink'
import anchors from 'views/assets/scripts/anchors'
import mobileDevice from 'views/assets/scripts/mobileDevice'
import mountSearchBoxContainer from 'views/containers/browser/SearchBoxContainer/mountSearchBoxContainer'
import mountSellerModalContainer from 'views/containers/browser/SellerModalContainer/mountSellerModalContainer'
import offCanvas from 'views/assets/scripts/offCanvas'
import youTubeVideo from 'views/assets/scripts/youTubeVideo'
import fullWidthElement from 'views/assets/scripts/fullWidthElement'
import adSlots from 'views/assets/scripts/adSlots'
import formBirthdaySelectValidation from 'views/assets/scripts/formValidation/formBirthdaySelectValidation'
import tabs from 'views/assets/scripts/tabs'
import searchBoxMobile from 'views/assets/scripts/searchBoxMobile'
import fetchMiniCartData from 'views/assets/scripts/fetchMiniCartData'
import handleMobileErxAnnouncement from 'views/assets/scripts/erxAnnouncement'
import {
  activateExperiments,
  startTrackingExperiments
} from 'views/assets/scripts/optimizely'

// Optimizely experiments
import xsellNewLayout from 'shared/experiments/browser/xsellNewLayout/xsellNewLayout'
import customerRedirectionModal from 'shared/experiments/browser/customerRedirectionModal'
import customerRedirectionEventsTracking from 'shared/experiments/browser/customerRedirectionModal/eventsTracking'
import serviceLinksEventsTracking from 'shared/experiments/browser/serviceLinks/eventsTracking'

type CallbackList = Array<CallableFunction>

const COMMON_SCRIPTS: CallbackList = [
  polyfills,
  initStore,
  handleUserSession,
  handleMobileErxAnnouncement,
  customerRedirectionModal,
  expander,
  formValidation,
  formControlValidation,
  floatingLabel,
  tooltip,
  copyLink,
  mobileDevice,
  anchors,
  offCanvas,
  modal,
  passwordReveal,
  select,
  asyncDataFetching,
  menubarFlyout,
  sticky,
  hover,
  scrollToTop,
  iframeWithHtml,
  mountSearchBoxContainer,
  mountSellerModalContainer,
  youTubeVideo,
  fullWidthElement,
  adSlots,
  activateExperiments,
  startTrackingExperiments,
  formBirthdaySelectValidation,
  tabs,
  searchBoxMobile,
  xsellNewLayout,
  fetchMiniCartData,
  customerRedirectionEventsTracking,
  serviceLinksEventsTracking
]

export const runSafeEachScript = (callbacks: CallbackList) => {
  callbacks.forEach(callback => {
    try {
      callback()
    } catch (error) {
      logger.error(`Cannot run client script ${callback.name}`, { error })
    }
  })
}

export default (...callbacks: CallbackList) =>
  ready(() =>
    // NB: `fetchUserSession` has to be executed last in order for all listeners to be attached
    runSafeEachScript([...COMMON_SCRIPTS, ...callbacks, fetchUserSession])
  )
